import PropTypes from 'prop-types';
import { Box, Chip } from '@mui/material';

import { formatDate } from 'helper/DateLib';
import { getDeadlineChipColor } from 'helper/actionsTable';
import { CalendarIcon } from 'assets/icons';

const styles = {
  chip: ({ palette }) => ({
    flexGrow: 1,
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 40,
    fontSize: 16,
    borderRadius: 6,
    color: palette.text.secondary,
    '&.MuiChip-colorDefault': {
      backgroundColor: palette.colors.liteLilac,
      '&:hover': {
        backgroundColor: palette.colors.liteLilac,
      },
    },
    '.MuiChip-label': {
      marginTop: 0.25,
    },
  }),
  pendingRowChip: ({ palette }) => ({
    backgroundColor: palette.colors.darkGrey,
    '&:hover': {
      backgroundColor: palette.colors.darkGrey,
    },
  }),
  chipIcon: ({ spacing, palette }) => ({
    width: 16,
    height: 16,
    margin: `${spacing(0, 2, 0, 0)} !important`,
    flex: 'none',
    color: `${palette.text.secondary} !important`,
  }),
  emptyChip: ({ palette }) => ({
    backgroundColor: 'transparent !important',
    border: `2px solid ${palette.error.main}`,
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '.MuiChip-label': {
      color: palette.colors.lightGrey,
    },
  }),
  emptyChipIcon: ({ palette }) => ({
    color: `${palette.error.main} !important`,
  }),
};

export const DataGridDateChip = ({ isPendingRow = false, onClick, dateValue = null, status, ref }) => {
  const isEmpty = !dateValue;
  const color = isEmpty ? 'default' : getDeadlineChipColor(status, dateValue);

  return (
    <Chip
      ref={ref}
      onClick={onClick}
      icon={<Box component={CalendarIcon} sx={[styles.chipIcon, isEmpty && styles.emptyChipIcon]} />}
      label={isEmpty ? 'dd/mm/yy' : formatDate(dateValue)}
      color={color}
      sx={[styles.chip, isPendingRow && styles.pendingRowChip, isEmpty && styles.emptyChip]}
    />
  );
};

DataGridDateChip.propTypes = {
  isPendingRow: PropTypes.bool,
  onClick: PropTypes.func,
  dateValue: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  status: PropTypes.string,
};
